module.exports = __webpack_public_path__ + "img/enToTh.e9f0c46a.png";